import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-login-register',
  templateUrl: './login-register.component.html',
  styleUrls: ['./login-register.component.scss']
})
export class LoginRegisterComponent implements OnInit {

  constructor(private title:Title,private meta:Meta,private renderer: Renderer2,@Inject(PLATFORM_ID) private platformId: Object) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
    this.setSeoMeta()
    }
  }
  setSeoMeta() {
    const supportedLanguages = ['en', 'fr', 'es', 'pt'];
    let finalUrl = '';
    let lang = 'en';
    let currentPath = '';
  
    if (isPlatformBrowser(this.platformId)) {
      const origin = window.location.origin;
      const path = window.location.pathname;
      const parts = path.split('/');
  
      if (supportedLanguages.includes(parts[1])) {
        lang = parts[1];
      }
  
      // const fullPath = path.replace(/^\/[a-z]{2}/, '');
      // currentPath = fullPath;
      // finalUrl = `${origin}/${lang}${fullPath}`;
      const fullPath = path.replace(/^\/[a-z]{2}/, '').replace(/\/+$/, ''); // remove trailing slash
finalUrl = `${origin}/${lang}${fullPath ? '/' + fullPath : ''}`;

    }
  
    // Translated SEO data for /login-register
    const seoByLang = {
      en: {
        title: 'Login or Register | Medeil Pharmacy Software',
        description: 'Access your Medeil account or create a new one. Manage your pharmacy, track inventory, billing, and prescriptions efficiently with our comprehensive pharmacy management platform.',
        keywords: 'login medeil, register medeil, pharmacy software login, pharmacy management registration',
        image: 'https://www.medeil.com/assets/login-register-banner.jpg'
      },
      fr: {
        title: 'Connexion ou Inscription | Logiciel de pharmacie Medeil',
        description: 'Connectez-vous à votre compte Medeil ou créez-en un nouveau. Gérez votre pharmacie, suivez les stocks, la facturation et les ordonnances efficacement avec notre plateforme complète.',
        keywords: 'connexion medeil, inscription medeil, logiciel de pharmacie, gestion pharmacie en ligne',
        image: 'https://www.medeil.com/assets/login-register-banner.jpg'
      },
      es: {
        title: 'Iniciar sesión o Registrarse | Software de farmacia Medeil',
        description: 'Accede a tu cuenta de Medeil o crea una nueva. Gestiona tu farmacia, controla inventario, facturación y recetas de forma eficiente con nuestra plataforma integral.',
        keywords: 'iniciar sesión medeil, registrarse medeil, software de farmacia, gestión de farmacia',
        image: 'https://www.medeil.com/assets/login-register-banner.jpg'
      },
      pt: {
        title: 'Entrar ou Registrar | Software de farmácia Medeil',
        description: 'Acesse sua conta Medeil ou crie uma nova. Gerencie sua farmácia, controle de estoque, faturamento e prescrições com eficiência usando nossa plataforma completa.',
        keywords: 'entrar medeil, registrar medeil, software de farmácia, gestão de farmácia online',
        image: 'https://www.medeil.com/assets/login-register-banner.jpg'
      }
    };
  
    // If not /login-register, you can fallback to default or add route-specific logic
    const seo = seoByLang[lang];
  
    const seoData = {
      ...seo,
      url: finalUrl
    };
  
    this.title.setTitle(seoData.title);
  
    const metaTags = [
      { name: 'description', content: seoData.description },
      { name: 'keywords', content: seoData.keywords },
      { property: 'og:title', content: seoData.title },
      { property: 'og:description', content: seoData.description },
      { property: 'og:url', content: seoData.url },
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: seoData.image }
    ];
  
    metaTags.forEach(tag => this.meta.updateTag(tag));
  }
  

}
